import React, { useState, useContext } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Button, ButtonToolbar, ButtonGroup } from '@/shared/components/Button';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import ConfirmationModal from '../ConfirmationModal';
import { AuthContext } from '../../../../../context/AuthContext';
// import ShowPaxtable from './ShowPaxtable';


const PendingCard = ({
 bookingData, setRefresh, 
}) => {
       const [confirmBokingModal, setConfirmBookingModal] = useState(false);
       const [bookingID, setBookinigID] = useState();
       const [Paxs, setPax] = useState([]);
       const [showPaxmodal, setShowPaxmodal] = useState(false);
       const { currencyCode, countryId } = useContext(AuthContext);
       const { apiGlobal } = useContext(GlobalVarContext);
    


      
   const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const openConfirmmodal = (id) => {
    setBookinigID(id);
    setConfirmBookingModal(true);
  };

  const handleConfirmBooking = async () => {
    const formData = new FormData();
    formData.append('id', bookingID);
     formData.append('isApproved', 2);
      formData.append('country_id', countryId);
    try {
      const url = await fetch(`${apiGlobal}/agent/booking_confirmation.php`, {
        method: 'POST',
        body: formData,
      });
      console.log(url);
      const response = await url.json();
      console.log(response);
      if (response?.status && response?.message === 'Success') {
        toast.success('Waiting for payment');
        setConfirmBookingModal(false);
        setRefresh(prev => !prev);
      } else {
        toast.error('Error in confirming booking');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showPaxDetailsModal = (paxDetails) => {
    setShowPaxmodal(true);
    setPax(paxDetails);
  };



  return (

    <div>
      {!bookingData ? (
        <div>Booking Data Not Passed</div> // Show message if no bookingData
      ) : (
        <div className="card mb-4 shadow-sm" style={{ maxWidth: '100%', borderColor: 'black' }}>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-12">
                {/* <h5 className="fw-bold">{bookingData.name}</h5> */}
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4" style={{ display: 'flex' }}>
                <h4 className="fw-bold d-flex">Trip:<p className="">{bookingData?.name}-{bookingData?.trip_uin}</p></h4>
              </div>
              <div className="col-md-4" style={{ display: 'flex' }}>
                <p className="mb-1">
                  <strong>Start Date:</strong> {bookingData?.start_date ? formatDate(bookingData?.start_date) : ''}
                </p>
                <p style={{ marginLeft: '12px' }}>
                  <strong>End Date:</strong>{bookingData?.end_date ? formatDate(bookingData?.end_date) : ''}
                </p>
              </div>

              <div className="col-md-4 text-end">
                {/*             
                <Button 
                  variant="outline-warning" 
                  size="sm" 
                  className="mx-1" 
                  title="Edit trip"
                >
                  Edit Trip
                </Button> */}
                {/* <Button 
                  onClick={() => addMealHandler(bookingData.id, bookingData.name)} 
                  variant="outline-primary" 
                  size="sm" 
                  className="mx-1" 
                  title="Add Meal"
                >
                  Add Meal
                </Button> */}
              </div>
            </div>

            {bookingData?.booking_details 
  && [...bookingData.booking_details]
    .sort((a, b) => (a?.status === '0' ? -1 : 1)) // Sort meals with status '0' first
    .map((meal, index) => (
      <div className="card mb-4 shadow-sm" key={meal?.id} style={{ maxWidth: '100%' }}>
        <div className="card-body">
          {/* Meal Day Header with Actions */}
          <div className="row mb-2 align-items-center" style={{ display: 'flex' }}>
            <div className="col-md-8 d-flex align-items-center">
              <h6 className="me-2">
                {meal?.day_name} - {meal?.booking_date ? formatDate(meal?.booking_date) : ''}
                {' '} 
                <span className={String(meal?.status) === '0' ? 'text-danger' : 'text-warning'}>
                  {/* ({String(meal.status) === '1' ? 'Awaiting Approval' : 'Awaiting Payment'}) */}
                </span>
              </h6>

              {/* <Button 
                variant="outline-success" 
                size="sm" 
                className="mx-2 mt-3" 
                title="Pay"
                onClick={() => showpaymentModal(meal.total_amount)}
              >
                Pay
              </Button> */}
              <Button 
                variant="outline-primary" 
                size="sm" 
                className="mx-2 mt-3 flex " 
                title=" View Paxs"
                onClick={() => showPaxDetailsModal(meal?.trip_pax_details)}
              >
                Paxs
              </Button>
              {meal.status === '1' && (
                <Button 
                  variant={String(meal?.status) === '1' ? 'outline-danger' : 'outline-success'}
                  size="sm"
                  className="mx-2 mt-3"
                  title="Approve"
                  onClick={String(meal?.status) === '1' && meal.id ? () => openConfirmmodal(meal?.id) : undefined}
                  disabled={String(meal?.status) !== '1'}
                >
                  {String(meal?.status) === '1' ? 'Approve' : 'Approved'}
                </Button>
              )}
            </div>
          </div>
          {/* Meal Details */}
          <div className="row border p-3 rounded">
            <div className="col-md-3">
              <p><strong>{meal?.meal_name}/{meal?.restaurant_name}</strong></p>
              <p className="text-muted">Locations: {meal?.location}</p>
            </div>
            <div className="col-md-3">
              <p>
                <strong>Timing:</strong> 
                {{
                  1: 'Breakfast',
                  2: 'Snacks',
                  3: 'Lunch',
                  4: 'Dinner',
                }[meal?.meal_offered] || 'Unknown'}
              </p>
              <p><strong>Total Meals:</strong> {meal?.total_meal}</p>
            </div>
            <div className="col-md-3">
              <p><strong>Type:</strong>   {{
                  1: 'Fit',
                  2: 'Git',
                  3: 'Delivery',
                  // 4: 'Dinner',
                }[meal?.meal_format] || 'Unknown'}
              </p>
              <p><strong>Format:</strong> {meal?.meal_type}</p>
            </div>
            <div className="col-md-3">
              {/* <p><strong>Amount:</strong> {currencyCode} {meal?.total_amount}</p> */}
              <p><strong>Amount:</strong>AED {meal?.total_amount}</p>
              <p>
                <strong>Status: </strong> 
                <span className="text-warning">.
                  {meal?.status === '1' 
                  ? 'Awaiting approval from restaurant' : <span style={{ color: 'red' }}>Payment pending</span>}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    ))}
          </div> 
          <ConfirmationModal 
            show={confirmBokingModal}
            handleClose={() => setConfirmBookingModal(false)}
            handleDelete={handleConfirmBooking}
            header="Confirm Booking"
            message="Are you sure you want to confirm this Booking?"
            buttonType="success"
            buttonText="Confirm"
          />
          <Modal
            show={showPaxmodal}
            onHide={() => setShowPaxmodal(false)}
            centered
            size="xl"
            backdrop="static" // Prevent clicking outside the modal to close it
            keyboard={false} 
            style={{
            display: 'none',
          }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Pax Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <ShowPaxtable paxDetails={Paxs} /> */}
            </Modal.Body>
          </Modal>
        </div>
)}
    </div>
  );
}; 

PendingCard.propTypes = {
  bookingData: PropTypes.shape({
    id: PropTypes.string.isRequired, 
    agent_id: PropTypes.string.isRequired, 
    name: PropTypes.string.isRequired, 
    trip_uin: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    booking_details: PropTypes.arrayOf(PropTypes.shape({


    })).isRequired,
  }).isRequired, 
 
  setRefresh: PropTypes.func.isRequired,
};



export default PendingCard;
